(() => {
  const normalize = (value) => String(value || '').toLocaleLowerCase('es').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  function initVideoModals(scope) {
    scope.querySelectorAll?.('[data-ul-video-open]').forEach((button) => {
      if (button.dataset.ulReady) return;
      button.dataset.ulReady = 'true';
      button.addEventListener('click', () => {
        const modal = document.getElementById(button.dataset.ulVideoOpen);
        if (!modal) return;
        const iframe = modal.querySelector('iframe[data-src]');
        if (iframe && !iframe.src) iframe.src = iframe.dataset.src;
        modal.classList.add('is-open');
        modal.style.setProperty('display', 'grid', 'important');
        modal.querySelector('[data-ul-video-close]')?.focus();
      });
    });
    scope.querySelectorAll?.('[data-ul-video-close]').forEach((button) => {
      if (button.dataset.ulReady) return;
      button.dataset.ulReady = 'true';
      button.addEventListener('click', () => {
        const modal = button.closest('.ul-video-modal');
        modal?.classList.remove('is-open');
        modal?.style.removeProperty('display');
        const iframe = modal?.querySelector('iframe');
        if (iframe) iframe.src = '';
      });
    });
  }

  function initTabs(scope) {
    scope.querySelectorAll?.('.ul-static__tabs').forEach((tabs) => {
      if (tabs.dataset.ulReady) return;
      tabs.dataset.ulReady = 'true';
      tabs.querySelectorAll('[role="tab"]').forEach((tab) => tab.addEventListener('click', () => {
        tabs.querySelectorAll('[role="tab"]').forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
        const root = tabs.parentElement;
        root?.querySelectorAll('[role="tabpanel"]').forEach((panel) => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
      }));
    });
  }

  function initStoryVideo(scope) {
    scope.querySelectorAll?.('[data-story-video-sound]').forEach((button) => {
      if (button.dataset.ulReady) return;
      button.dataset.ulReady = 'true';
      button.addEventListener('click', () => {
        const iframe = document.getElementById(button.getAttribute('aria-controls'));
        if (!iframe?.contentWindow) return;
        const soundOn = button.getAttribute('aria-pressed') === 'true';
        iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: soundOn ? 'mute' : 'unMute', args: [] }), '*');
        if (!soundOn) iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'setVolume', args: [100] }), '*');
        button.setAttribute('aria-pressed', String(!soundOn));
        button.textContent = soundOn ? 'ACTIVAR SONIDO' : 'SILENCIAR';
      });
    });
  }

  function initSizeCalculator(scope) {
    scope.querySelectorAll?.('[data-size-calculator]').forEach((form) => {
      if (form.dataset.ulReady) return;
      form.dataset.ulReady = 'true';
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const cm = Number(String(form.querySelector('[data-size-cm]')?.value || '').replace(',', '.'));
        const rows = [...document.querySelectorAll('#panel-hombre tbody tr[data-cm]')];
        if (!Number.isFinite(cm) || !rows.length) return;
        const row = rows.reduce((best, current) => Math.abs(Number(current.dataset.cm) - cm) < Math.abs(Number(best.dataset.cm) - cm) ? current : best);
        const extra = form.querySelector('[data-size-width]')?.value !== 'normal';
        const index = Math.min(rows.length - 1, rows.indexOf(row) + (extra ? 1 : 0));
        rows.forEach((item) => item.classList.toggle('is-recommended', item === rows[index]));
        const output = form.querySelector('[data-size-result]');
        if (output) {
          output.querySelector('.ul-static__result-size').textContent = rows[index].dataset.mxLabel;
          const copy = output.querySelector('p');
          if (copy) copy.textContent = extra ? 'Ajuste sugerido considerando volumen adicional.' : 'Referencia inicial según tu medida M1.';
        }
      });
    });
  }

  function initFaq(scope) {
    const page = scope.querySelector?.('.ul-static--preguntas-frecuentes') || (scope.matches?.('.ul-static--preguntas-frecuentes') ? scope : null);
    if (!page || page.dataset.ulReady) return;
    page.dataset.ulReady = 'true';
    const input = page.querySelector('[data-faq-search]');
    const groups = [...page.querySelectorAll('[data-faq-group]')];
    const items = [...page.querySelectorAll('.faq-item')];
    const buttons = [...page.querySelectorAll('[data-faq-filter]')];
    const count = page.querySelector('[data-faq-count]');
    const empty = page.querySelector('[data-faq-empty]');
    let category = 'all';
    const update = () => {
      const query = normalize(input?.value);
      let visible = 0;
      items.forEach((item) => {
        const match = (category === 'all' || item.dataset.category === category) && (!query || normalize(item.dataset.search).includes(query));
        item.hidden = !match;
        if (match) visible += 1;
      });
      groups.forEach((group) => { group.hidden = ![...group.querySelectorAll('.faq-item')].some((item) => !item.hidden); });
      if (count) count.textContent = `${visible} respuestas`;
      if (empty) empty.hidden = visible !== 0;
    };
    input?.addEventListener('input', update);
    page.querySelector('[data-faq-clear]')?.addEventListener('click', () => { if (input) input.value = ''; category = 'all'; buttons.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.faqFilter === 'all'))); update(); });
    buttons.forEach((button) => button.addEventListener('click', () => { category = button.dataset.faqFilter; buttons.forEach((b) => b.setAttribute('aria-pressed', String(b === button))); update(); }));
  }

  function initContact(scope) {
    scope.querySelectorAll?.('.ul-static--contacto').forEach((page) => {
      if (page.dataset.ulReady) return;
      page.dataset.ulReady = 'true';
      const panel = page.querySelector('.contact-form-preview');
      const reason = page.querySelector('[data-contact-form-reason]');
      page.querySelectorAll('.js-open-form').forEach((button) => button.addEventListener('click', () => {
        if (panel) panel.hidden = false;
        const requested = button.dataset.formReason;
        if (reason && requested) reason.value = requested;
        panel?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }));
      page.querySelector('[data-contact-form-close]')?.addEventListener('click', () => { if (panel) panel.hidden = true; });
    });
  }

  function initStores(scope) {
    scope.querySelectorAll?.('.ul-static--store-locator').forEach((page) => {
      if (page.dataset.ulReady) return;
      page.dataset.ulReady = 'true';
      const cards = [...page.querySelectorAll('.store-card')];
      const search = page.querySelector('[data-store-search]');
      const region = page.querySelector('[data-store-region]');
      const count = page.querySelector('[data-store-count] strong');
      const empty = page.querySelector('[data-store-empty]');
      const detail = page.querySelector('[data-store-detail]');
      const detailName = page.querySelector('[data-store-detail-name]');
      const detailAddress = page.querySelector('[data-store-detail-address]');
      const detailMeta = page.querySelector('[data-store-detail-meta]');
      const detailLink = page.querySelector('[data-store-detail-link]');
      const websiteLink = page.querySelector('[data-store-website-link]');
      const mapElement = page.querySelector('[data-store-map]');
      let markerRecords = [];
      let quick = 'all';
      const update = () => {
        const query = normalize(search?.value);
        let visible = 0;
        cards.forEach((card) => {
          const matches = (!query || normalize(card.dataset.search).includes(query)) && (!region || region.value === 'all' || card.dataset.region === region.value) && (quick === 'all' || normalize(card.dataset.filter).includes(normalize(quick)));
          card.hidden = !matches;
          const markerRecord = markerRecords.find((record) => record.card === card);
          if (markerRecord) {
            markerRecord.marker.hidden = !matches;
          }
          if (matches) visible += 1;
        });
        if (count) count.textContent = visible;
        if (empty) empty.hidden = visible !== 0;
      };
      page.querySelector('[data-store-locator-form]')?.addEventListener('submit', (event) => { event.preventDefault(); update(); });
      search?.addEventListener('input', update);
      region?.addEventListener('change', update);
      page.querySelectorAll('[data-store-filter]').forEach((button) => button.addEventListener('click', () => { quick = button.dataset.storeFilter; page.querySelectorAll('[data-store-filter]').forEach((item) => item.setAttribute('aria-pressed', String(item === button))); update(); }));
      const selectStore = (card) => {
        cards.forEach((item) => item.classList.toggle('is-selected', item === card));
        if (detailName) detailName.textContent = card.querySelector('h3')?.textContent || '';
        if (detailAddress) detailAddress.innerHTML = card.querySelector('address')?.innerHTML || '';
        if (detailMeta) detailMeta.textContent = [card.dataset.place, card.dataset.phone].filter(Boolean).join(' · ');
        if (detailLink) {
          detailLink.href = card.dataset.storeUrl || '#';
          detailLink.hidden = !card.dataset.storeUrl;
        }
        if (websiteLink) {
          websiteLink.href = card.dataset.website || '#';
          websiteLink.hidden = !card.dataset.website;
        }
        detail?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      };
      cards.forEach((card) => {
        card.addEventListener('click', () => selectStore(card));
        card.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          selectStore(card);
        });
      });
      if (mapElement) {
        mapElement.innerHTML = '<div class="store-map-land store-map-land--north-america" aria-hidden="true"></div><div class="store-map-land store-map-land--south-america" aria-hidden="true"></div><div class="store-map-land store-map-land--eurasia" aria-hidden="true"></div><div class="store-map-land store-map-land--australia" aria-hidden="true"></div>';
        markerRecords = cards.flatMap((card) => {
          const x = Number(card.dataset.mapX);
          const y = Number(card.dataset.mapY);
          if (!Number.isFinite(x) || !Number.isFinite(y)) return [];
          const marker = document.createElement('button');
          marker.type = 'button';
          marker.className = 'store-map-pin';
          marker.style.left = `${x}%`;
          marker.style.top = `${y}%`;
          marker.title = card.querySelector('h3')?.textContent || '';
          marker.setAttribute('aria-label', marker.title);
          marker.textContent = '•';
          marker.addEventListener('click', () => selectStore(card));
          mapElement.appendChild(marker);
          return [{ card, marker }];
        });
        update();
      }
      update();
    });
  }

  function init(scope = document) {
    initVideoModals(scope);
    initStoryVideo(scope);
    initTabs(scope);
    initSizeCalculator(scope);
    initFaq(scope);
    initContact(scope);
    initStores(scope);
  }

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
